module.exports = __webpack_public_path__ + "img/STERiGLIDE_02.2b825764.jpg";